import React from "react";

const ModalBackground = ({ className }) => (
  <svg
    className={className}
    width="204"
    height="278"
    viewBox="0 0 204 278"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="204" height="278" rx="6" fill="#090909" />

    <g clipPath="url(#clip0)">
      <path
        d="M204 -0.257812H83.0006C83.0006 29.2444 93.7315 56.2555 111.543 77.1433L115.303 69.0333C118.036 63.1389 118.036 56.3544 115.303 50.4589L99.2662 15.8833L134.131 31.7866C140.075 34.4966 146.916 34.4966 152.869 31.7866L187.724 15.8833L171.698 50.46C168.956 56.3544 168.956 63.1389 171.698 69.0344L187.724 103.611L152.869 87.7077C146.916 84.9977 140.075 84.9977 134.131 87.7077L125.954 91.4366C147.015 109.101 174.262 119.742 204 119.742V-0.257812Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M109.687 107.567L83 119.742L95.276 93.2751C97.4696 95.8562 99.7731 98.3384 102.177 100.723C104.581 103.106 107.084 105.391 109.687 107.567Z"
        fill="url(#paint1_linear)"
      />
    </g>

    <g opacity="0.08">
      <path
        d="M36 195.469H0C0 204.319 3.1927 212.423 8.49208 218.689L9.61075 216.256C10.4238 214.488 10.4238 212.452 9.61075 210.684L4.83938 200.311L15.2125 205.082C16.9808 205.895 19.0162 205.895 20.7875 205.082L31.1576 200.311L26.3896 210.684C25.5736 212.452 25.5736 214.488 26.3896 216.256L31.1576 226.629L20.7875 221.858C19.0162 221.045 16.9808 221.045 15.2125 221.858L12.7795 222.977C19.0458 228.276 27.1523 231.468 36 231.468V195.469Z"
        fill="white"
      />
      <path
        d="M7.94007 227.817L0 231.469L3.65237 223.529C4.30504 224.304 4.99038 225.048 5.70572 225.764C6.42073 226.479 7.1654 227.164 7.94007 227.817Z"
        fill="white"
      />
      <g transform="translate(49.5879 197.027)">
        <path
          d="M96.3008 34V0H119.673V7.28566H103.761V12.8227H113.724V20.1084H103.761V34H96.3008Z"
          fill="white"
        />
        <path
          d="M0 34V0H15.9593C18.698 0 20.8661 0.449556 22.4634 1.34795C24.0606 2.24635 25.202 3.40021 25.8867 4.80847C26.5714 6.21708 26.9137 7.69062 26.9137 9.22839C26.9137 10.7662 26.6577 12.1184 26.1465 13.3811C25.6349 14.6441 24.6786 15.6074 23.2781 16.2711C24.4268 16.7246 25.3477 17.3725 26.0404 18.2138C26.733 19.0558 27.2325 19.9746 27.5398 20.9704C27.8467 21.9658 28 22.9092 28 23.7997C28 25.0303 27.7954 26.2527 27.3865 27.4668C26.9768 28.6813 26.3275 29.7781 25.4386 30.7575C24.5493 31.7372 23.3766 32.5225 21.9209 33.113C20.4652 33.7042 18.6824 33.9996 16.5736 33.9996H0.000347183L0 34ZM7.46027 13.1631H15.2511C16.6676 13.1631 17.6984 12.8919 18.3439 12.3492C18.989 11.8073 19.3119 11.0744 19.3119 10.1514C19.3119 9.68187 19.2328 9.22054 19.0757 8.7667C18.9183 8.31393 18.6033 7.93752 18.1313 7.63746C17.6589 7.33811 16.951 7.18826 16.0065 7.18826H7.45992V13.1627L7.46027 13.1631ZM7.46027 26.7629H16.9038C17.8007 26.7629 18.5093 26.593 19.0286 26.253C19.5478 25.9126 19.9137 25.5002 20.1263 25.0142C20.3386 24.5283 20.4451 24.0591 20.4451 23.6056C20.4451 23.039 20.323 22.4846 20.0791 21.9419C19.835 21.3999 19.3667 20.9507 18.6744 20.5943C17.9818 20.2382 16.9666 20.0598 15.6288 20.0598H7.46027V26.7625V26.7629Z"
          fill="white"
        />
        <path d="M33.5039 34V0H40.9642V34H33.5039Z" fill="white" />
        <path
          d="M47.8109 34V0H54.5629L66.5089 17.243C66.6504 17.4535 66.8786 17.8342 67.1936 18.3843C67.5082 18.9349 67.7367 19.3962 67.8783 19.7687C67.8311 19.4451 67.7957 18.9955 67.7721 18.4207C67.7485 17.8463 67.7367 17.4371 67.7367 17.1945V0H75.1498V34H68.6808L56.4515 16.6115C56.294 16.3849 56.062 15.9885 55.755 15.4216C55.4481 14.855 55.208 14.3772 55.035 13.9887C55.1137 14.4258 55.1567 14.8914 55.1647 15.3848C55.1727 15.879 55.1765 16.2875 55.1765 16.6111V33.9996H47.8105L47.8109 34Z"
          fill="white"
        />
        <path d="M81.9922 34V0H89.4525V34H81.9922Z" fill="white" />
        <path
          d="M133.932 34V20.7888L121.23 0H129.635L137.615 12.629L145.548 0H154L141.298 20.7888V34H133.932H133.932Z"
          fill="white"
        />
      </g>
    </g>

    <rect y="225" width="204" height="54" fill="black" />

    <g filter="url(#filter0_f)">
      <ellipse cx="102" cy="284.374" rx="102" ry="58.3303" fill="#FF5500" />
    </g>
    <g filter="url(#filter1_f)">
      <ellipse
        cx="-24.4355"
        cy="-24.6424"
        rx="102"
        ry="58.3303"
        fill="#FF5500"
        fillOpacity="0.3"
      />
    </g>

    <defs>
      <filter
        id="filter0_f"
        x="-60"
        y="166"
        width="324"
        height="236"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="filter1_f"
        x="-186.436"
        y="-142.973"
        width="324"
        height="236"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur" />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="204"
        y1="-0.257813"
        x2="88.5588"
        y2="113.081"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2B2E39" />
        <stop offset="1" stopColor="#090909" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="83"
        y1="106.509"
        x2="109.687"
        y2="106.509"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2B2E39" />
        <stop offset="1" stopColor="#090909" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="204" height="278" rx="6" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ModalBackground;
